import { Grid, Paper, Typography, FormControl, InputLabel, Select, MenuItem } from "@mui/material";
import { SearchRecords } from "./SearchRecords";
import React from "react";

export const TableFilter = ({ handlePagination, pagination }) => {
    const handleStatusChange = (event) => {
        const value = event.target.value; // '' | 'true' | 'false'
        handlePagination({ ...pagination, pageNo: 0, active: value });
    };

    return (
        <Paper sx={{ padding: 1.5 }}>
            <Grid container justifyContent={"space-between"} alignItems="center" spacing={2}>
                <Grid item sx={{ alignSelf: "center" }}>
                    <Typography variant="h6">Filter</Typography>
                </Grid>

                <Grid item xs={6} sm={4} md={3}>
                    <FormControl fullWidth size="small">
                        <InputLabel id="status-filter-label">Status</InputLabel>
                        <Select
                            labelId="status-filter-label"
                            id="status-filter"
                            value={pagination.active ?? ""}
                            label="Status"
                            onChange={handleStatusChange}
                        >
                            <MenuItem value={""}>All</MenuItem>
                            <MenuItem value={"true"}>Active</MenuItem>
                            <MenuItem value={"false"}>Inactive</MenuItem>
                        </Select>
                    </FormControl>
                </Grid>

                <Grid item xs>
                    <SearchRecords handlePagination={handlePagination} pagination={pagination} />
                </Grid>
            </Grid>
        </Paper>
    );
};